import { useNullableDealerAccountInfo } from "./useNullableDealerAccountInfo";
import { useSearchForm } from "./useSearchForm";

export const useDealerId = (): string => {
  const [{ dealerId }] = useSearchForm();
  const dealer = useNullableDealerAccountInfo();
  return dealer?.dealerId ?? dealerId ?? "0";
  // return dealerId ?? dealer?.dealerId ?? "0";
};
